import { apiService } from './api';
import { User, CreateUserData, UpdateUserData, ChangePasswordData, ApiResponse } from '../types';

export const userService = {
  async getUsers(): Promise<ApiResponse<User[]>> {
    return apiService.get<User[]>('/api/users');
  },

  async getModerators(): Promise<ApiResponse<User[]>> {
    return apiService.get<User[]>('/api/users/moderators');
  },

  async createUser(userData: CreateUserData): Promise<ApiResponse<User>> {
    return apiService.post<User>('/api/users', userData);
  },

  async updateUser(userId: number, userData: UpdateUserData): Promise<ApiResponse<User>> {
    return apiService.put<User>(`/api/users/${userId}`, userData);
  },

  async deleteUser(userId: number): Promise<ApiResponse<void>> {
    return apiService.delete<void>(`/api/users/${userId}`);
  },

  async getProfile(): Promise<ApiResponse<User>> {
    return apiService.get<User>('/api/users/profile');
  },

  async updateProfile(userData: UpdateUserData): Promise<ApiResponse<User>> {
    return apiService.put<User>('/api/users/profile', userData);
  },

  async changePassword(passwordData: ChangePasswordData): Promise<ApiResponse<void>> {
    return apiService.put<void>('/api/users/profile/password', passwordData);
  },
};

